import { render } from "./BuyerNavCogIcon.vue?vue&type=template&id=a0ae724c"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__